import { lazy, Suspense } from 'react'
import { LoadingSpinner } from '@/components/common/LoadingSpinner'

const StorefrontPage = lazy(() =>
  import('@/pages/Storefront/StorefrontPage').then(m => ({ default: m.StorefrontPage }))
)

interface SubdomainStorefrontProps {
  slug: string
  /** Pin to a known seller UID and skip the slug -> UID lookup. */
  sellerId?: string
}

/**
 * Wrapper component used by the subdomain router.
 * Renders the StorefrontPage with a slug derived from the hostname
 * rather than from URL params.
 */
export function SubdomainStorefront({ slug, sellerId }: SubdomainStorefrontProps) {
  return (
    <Suspense
      fallback={
        <div className="flex items-center justify-center min-h-[60vh]">
          <LoadingSpinner size="lg" />
        </div>
      }
    >
      <StorefrontPage slugOverride={slug} sellerIdOverride={sellerId} />
    </Suspense>
  )
}
